
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconTrash from '@components/icons/icon-trash.svg';

@Component({
  name: 'SettingsDelete',
  components: {
    IconTrash
  }
})
export default class SettingsDelete extends Vue {
  @Prop()
  private disabled: boolean;
}
